import React from 'react'
import Style from './userContainer.module.scss'

export const UserContainer = (props) => (
  <div className={Style.userContainer}>{props.children}</div>
)
